import { Col, InputNumber } from "antd";
import Colors from "assets/Colors";
import s from "../styles";

function Items({
  item,
  itemVariant,
  index,
  placeholder,
  price,
  onPriceChange,
}) {
  const generateVariantCombinations = (variants) => {
    if (!variants || variants.length === 0) return {};

    const combine = (arr) => {
      if (arr.length === 0) return [[]];
      const first = arr[0];
      const rest = combine(arr.slice(1));
      return first.items.flatMap((item) =>
        rest.map((combination) => [item, ...combination])
      );
    };

    const combinations = combine(variants);

    const result = {};

    const firstVariant = variants[0];
    firstVariant.items.forEach((item) => {
      result[item.value] = [item.name];
    });

    combinations.forEach((combination) => {
      if (combination.length > 1) {
        const key = combination.map((item) => item.value).join("");
        const values = combination.map((item) => item.name);
        result[key] = values;
      }
    });

    return result;
  };

  const variantCombinations =
    itemVariant?.variants && generateVariantCombinations(itemVariant.variants);

  return (
    <s.OptionRow style={{ background: index % 2 !== 0 && Colors.BG_MENU }}>
      <Col span={9}>
        <s.Text>{item?.variant}</s.Text>
      </Col>
      <Col span={9}>
        <s.Text>{variantCombinations?.[item?.variant]?.join(" , ")}</s.Text>
      </Col>
      <Col span={6}>
        <InputNumber
          placeholder={`${placeholder}`}
          name="price"
          value={price}
          onChange={(value) => onPriceChange(value, `${item.variant}`)}
        />
      </Col>
    </s.OptionRow>
  );
}

export default Items;
